<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <path
      d="M27.5 13.3333H12.5C11.5795 13.3333 10.8333 14.0794 10.8333 14.9999V24.9999C10.8333 25.9204 11.5795 26.6666 12.5 26.6666H27.5C28.4205 26.6666 29.1667 25.9204 29.1667 24.9999V14.9999C29.1667 14.0794 28.4205 13.3333 27.5 13.3333Z"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8333 18.3333H29.1667"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
